module.exports = __webpack_public_path__ + "static/media/motorcycle.ae09d046.svg";